import { render, staticRenderFns } from "./abbreviate.vue?vue&type=template&id=66a46e79&"
import script from "./abbreviate.vue?vue&type=script&lang=js&"
export * from "./abbreviate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports